import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { KitProvider } from "./hooks/useKit";
import { ProfileProvider } from "./contexts/ProfileContext";
import AuthModal from "./components/AuthModal";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Library from "./pages/Library";
import LibraryDetail from "./pages/LibraryDetail";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import FirstAidKit from "./pages/FirstAidKit";
import Favorites from "./pages/Favorites";
import AskSage from "./pages/AskSage";
import About from "./pages/About";
import Membership from "./pages/Membership";
import Search from "./pages/Search";
import Checkout from "./pages/Checkout";
import PremiumSuccess from "./pages/PremiumSuccess";
import ProfilePage from "./pages/ProfilePage";
import ShoppingList from "./pages/ShoppingList";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/library" element={<Library />} />
          <Route path="/library/:id" element={<LibraryDetail />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipes/:id" element={<RecipeDetail />} />
          <Route path="/shopping-list" element={<ShoppingList />} />
          <Route path="/kit" element={<FirstAidKit />} />
          <Route path="/first-aid-kit" element={<FirstAidKit />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/ask" element={<AskSage />} />
          <Route path="/about" element={<About />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/premium/success" element={<PremiumSuccess />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/search" element={<Search />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-botanica-bg">
      <BrowserRouter>
        <AuthProvider>
          <KitProvider>
            <ProfileProvider>
              <AppRouter />
              <AuthModal />
              <Toaster position="top-center" richColors />
            </ProfileProvider>
          </KitProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
